<template>
  <div style="min-height:80vh">
    <v-layout pt-12></v-layout>
    <v-layout wrap pt-12 px-2 justify-center>
      <v-flex xs12 md2 align="center">
        <v-img src="../../assets/icons/tick.png" aspect-ratio="1" contain height="50px">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-flex>
      <v-flex xs12 md12 text-center>
        <span style="font-size:18px;color:#000;font-weight:400">
          Thank you for contacting Ecosystem Investor Platform.
          <br />Your query is important to us. We will get in touch with you in the next few days.
        </span>
      </v-flex>
      <v-flex xs12 md12 align="center">
        <v-img src="../../assets/person.png" contain height="200px">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["loginData"],
  data() {
    return {
      appLoading: true
    };
  },
  beforeMount() {
    this.submit();
  },
  methods: {
    submit() {
      setTimeout(() => {
        this.$router.push("/");
      }, 5000);
    }
  }
};
</script>